var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWorkspaceIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 107,
    height: 59,
    viewBox: "0 0 107 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1092_356)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.65392 22.6353L0.883301 29.4754L18.9546 47.7322C22.6834 51.4992 28.7671 51.4992 32.5122 47.7322L39.2829 40.8921L21.2115 22.6353C17.4664 18.8683 11.399 18.8683 7.65392 22.6353ZM30.239 45.4522C27.7532 47.9635 23.6973 47.9635 21.2115 45.4522L5.39705 29.4754L9.9108 24.9154C12.3966 22.404 16.4524 22.404 18.9383 24.9154L34.7527 40.8921L30.239 45.4522Z",
    fill: "url(#paint0_linear_1092_356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.284 11.2681C96.555 7.50112 90.4713 7.50112 86.7261 11.2681L60.7067 37.5711L59.6764 38.612L43.8619 22.6352C40.1331 18.8682 34.0494 18.8682 30.3043 22.6352L25.7905 27.1953L23.5337 29.4753L41.605 47.7321C45.3338 51.4991 51.4175 51.4991 55.1626 47.7321L59.1367 43.7173L59.6764 43.1721L64.1901 47.7321C67.9189 51.4991 74.0026 51.4991 77.7477 47.7321L104.814 20.3882L107.071 18.1082L100.284 11.2681ZM54.2631 44.0643L52.8894 45.4521C50.4036 47.9634 46.3477 47.9634 43.8619 45.4521L36.2572 37.7694L28.0474 29.4753L32.5612 24.9153C35.047 22.4039 39.1028 22.4039 41.5887 24.9153L57.4031 40.892L54.2631 44.0643ZM75.4908 45.4521C73.005 47.9634 68.9492 47.9634 66.4633 45.4521L61.9496 40.892L85.8594 16.7369L89.0648 13.4986C91.5506 10.9872 95.6065 10.9872 98.0923 13.4986L98.1414 13.5481L102.606 18.0586L75.4908 45.4521Z",
    fill: "url(#paint1_linear_1092_356)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.6632 38.6118L57.4082 40.8899L59.6632 43.168L61.9182 40.8899L59.6632 38.6118Z",
    fill: "#231F20"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7425 11.268L52.8894 45.452C50.4036 47.9633 46.3477 47.9633 43.8619 45.452L25.7905 27.1952L23.5337 29.4752L41.605 47.732C45.3338 51.499 51.4175 51.499 55.1626 47.732L89.0321 13.515C91.518 11.0037 95.5738 11.0037 98.0596 13.515L104.83 20.3551L107.038 18.1246L100.267 11.2845C96.555 7.50102 90.4713 7.50102 86.7425 11.268Z",
    fill: "url(#paint2_linear_1092_356)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1092_356",
    x1: 32.5406,
    y1: 35.1873,
    x2: 70.9386,
    y2: 35.1873,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E57BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1092_356",
    x1: 25.3862,
    y1: 29.5041,
    x2: 108.915,
    y2: 29.5041,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E57BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8283,
    stopColor: "#3BB3E7"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1092_356",
    x1: 41.6037,
    y1: 47.738,
    x2: 89.477,
    y2: 0.350927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1E57BD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3BB3E7"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1092_356"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 107,
    height: 59,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWorkspaceIcon);
export default __webpack_public_path__ + "static/media/workspace-icon.1274bf549148cf478c7176c7f3dc9408.svg";
export { ForwardRef as ReactComponent };